export default __webpack_public_path__ + "static/media/2-4-selectFacility.c807a11c.png";